import { MarginExample } from 'components/designSystem/utilityClasses/MarginExample';
import { UtilityClass } from 'components/designSystem/utilityClasses/UtilityClass';
import { UtilityClassSectionHeader } from 'components/designSystem/utilityClasses/UtilityClassSectionHeader';
import { Section } from 'components/shared/Section';

const margins = [
    <UtilityClassSectionHeader key="1" />,
    <div key="2">
        <UtilityClass
            className=".margin__top--xx-small"
            example={<MarginExample className="margin__top--xx-small" />}
        />
        <UtilityClass
            className=".margin__top--x-small"
            example={<MarginExample className="margin__top--x-small" />}
        />
        <UtilityClass
            className=".margin__top--small"
            example={<MarginExample className="margin__top--small" />}
        />
        <UtilityClass
            className=".margin__top--medium"
            example={<MarginExample className="margin__top--medium" />}
        />
        <UtilityClass
            className=".margin__top--large"
            example={<MarginExample className="margin__top--large" />}
        />
        <UtilityClass
            className=".margin__top--x-large"
            example={<MarginExample className="margin__top--x-large" />}
        />
        <UtilityClass
            className=".margin__top--xx-large"
            example={<MarginExample className="margin__top--xx-large" />}
        />
        <UtilityClass
            className=".margin__bottom--xx-small"
            example={<MarginExample className="margin__bottom--xx-small" />}
        />
        <UtilityClass
            className=".margin__bottom--x-small"
            example={<MarginExample className="margin__bottom--x-small" />}
        />
        <UtilityClass
            className=".margin__bottom--small"
            example={<MarginExample className="margin__bottom--small" />}
        />
        <UtilityClass
            className=".margin__bottom--medium"
            example={<MarginExample className="margin__bottom--medium" />}
        />
        <UtilityClass
            className=".margin__bottom--large"
            example={<MarginExample className="margin__bottom--large" />}
        />
        <UtilityClass
            className=".margin__bottom--x-large"
            example={<MarginExample className="margin__bottom--x-large" />}
        />
        <UtilityClass
            className=".margin__bottom--xx-large"
            example={<MarginExample className="margin__bottom--xx-large" />}
        />
        <UtilityClass
            className=".margin__left--xx-small"
            example={<MarginExample className="margin__left--xx-small" />}
        />
        <UtilityClass
            className=".margin__left--x-small"
            example={<MarginExample className="margin__left--x-small" />}
        />
        <UtilityClass
            className=".margin__left--small"
            example={<MarginExample className="margin__left--small" />}
        />
        <UtilityClass
            className=".margin__left--medium"
            example={<MarginExample className="margin__left--medium" />}
        />
        <UtilityClass
            className=".margin__left--large"
            example={<MarginExample className="margin__left--large" />}
        />
        <UtilityClass
            className=".margin__left--x-large"
            example={<MarginExample className="margin__left--x-large" />}
        />
        <UtilityClass
            className=".margin__left--xx-large"
            example={<MarginExample className="margin__left--xx-large" />}
        />
        <UtilityClass
            className=".margin__right--xx-small"
            example={<MarginExample className="margin__right--xx-small" />}
        />
        <UtilityClass
            className=".margin__right--x-small"
            example={<MarginExample className="margin__right--x-small" />}
        />
        <UtilityClass
            className=".margin__right--small"
            example={<MarginExample className="margin__right--small" />}
        />
        <UtilityClass
            className=".margin__right--medium"
            example={<MarginExample className="margin__right--medium" />}
        />
        <UtilityClass
            className=".margin__right--large"
            example={<MarginExample className="margin__right--large" />}
        />
        <UtilityClass
            className=".margin__right--x-large"
            example={<MarginExample className="margin__right--x-large" />}
        />
        <UtilityClass
            className=".margin__right--xx-large"
            example={<MarginExample className="margin__right--xx-large" />}
        />
        <UtilityClass
            className=".margin__around--xx-small"
            example={<MarginExample className="margin__around--xx-small" />}
        />
        <UtilityClass
            className=".margin__around--x-small"
            example={<MarginExample className="margin__around--x-small" />}
        />
        <UtilityClass
            className=".margin__around--small"
            example={<MarginExample className="margin__around--small" />}
        />
        <UtilityClass
            className=".margin__around--medium"
            example={<MarginExample className="margin__around--medium" />}
        />
        <UtilityClass
            className=".margin__around--large"
            example={<MarginExample className="margin__around--large" />}
        />
        <UtilityClass
            className=".margin__around--x-large"
            example={<MarginExample className="margin__around--x-large" />}
        />
        <UtilityClass
            className=".margin__around--xx-large"
            example={<MarginExample className="margin__around--xx-large" />}
        />
    </div>,
];

export const Margin = () => <Section title="Margin Utility Classes" contentArray={margins} />;
